export const IMAGE_WIDTH_DESKTOP = 205;
export const IMAGE_HEIGHT_DESKTOP = 75;
export const IMAGE_WIDTH_MOBILE = 140;
export const IMAGE_HEIGHT_MOBILE = 44;
export const SECTION_NAME = 'product_cards_section';
